module.exports = __webpack_public_path__ + "img/main_2_2.5949c84d.png";